export default (x) => {
    let label = x.name;
    if (x.postCode || x.city) {
        label += " (";
        if (x.postCode) {
            label += x.postCode;
        }
        if (x.city) {
            label += ", " + x.city;
        }
        label += ")";
    }
    return label;
}
